// Apps móviles: política de versiones (actualización obligatoria o sugerida, mantenimiento) y términos de cada app.
// Rutas de axium-backend (com.axium.appconfig.AppConfigController), solo personal de Axium (token CORE), con la respuesta
// envuelta en `{ error, status_code, data }`. El token lo agrega el interceptor global de axiosInstance.
import axiosInstance from '../utils/AxiosConfig';

const AppConfigAdminService = {
  async getApps() {
    const response = await axiosInstance.get('/admin/apps');
    return response.data?.data || [];
  },

  // Todas las versiones de los tres documentos de la app (TERMS, PRIVACY y DATA_DELETION).
  async getDocuments(appKey) {
    const response = await axiosInstance.get(`/admin/apps/${appKey}/documents`);
    return response.data?.data || [];
  },

  async savePolicy(appKey, platform, policy) {
    const response = await axiosInstance.put(`/admin/apps/${appKey}/policy/${platform}`, policy);
    return response.data?.data;
  },

  // `type`: terms, privacy o data-deletion.
  async publishDocument(appKey, type, text, changeSummary) {
    const response = await axiosInstance.post(`/admin/apps/${appKey}/documents/${type}/publish`, { text, changeSummary });
    return response.data?.data;
  },
};

export default AppConfigAdminService;
